import { createContext } from 'react'

export const BalanceContext = createContext({
  balanceRefetch: () => null,
  balance: 0,
})
